import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

declare global {
  interface Window {
    dataLayer: any[]
  }
}

const trackingEventNames = {
  route_change: 'route-change',
  ga_trigger: 'ga_trigger',
}

export const trackingPushEvent = (event: {
  name: keyof typeof trackingEventNames
  data?: Record<string, any>
}) => {
  const data = event.data ?? {}

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: trackingEventNames[event.name],
    ...data,
  })
  console.log('[TRACKING]', trackingEventNames[event.name], data)
}

export const useTracking = () => {
  const location = useLocation()

  useEffect(() => {
    trackingPushEvent({
      name: `route_change`,
      data: { pathname: location.pathname },
    })

    trackingPushEvent({
      name: `ga_trigger`,
      data: { pathname: location.pathname },
    })
  }, [location.pathname])
}
